import { render, staticRenderFns } from "./dataPolice.vue?vue&type=template&id=9ee42430&scoped=true"
import script from "./dataPolice.vue?vue&type=script&lang=js"
export * from "./dataPolice.vue?vue&type=script&lang=js"
import style0 from "./dataPolice.vue?vue&type=style&index=0&id=9ee42430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee42430",
  null
  
)

export default component.exports